/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
// @ts-expect-error no typings
import { ObjectTypeId } from 'customer-data-objects-ui-components/propTypes/CrmObjectTypes';
import UIButton from 'UIComponents/button/UIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { COMPANY_TYPE_ID, CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import openCallingWidget from 'calling-global-api/methods/openCallingWidget';
import { translateObjectName } from 'customer-data-objects/record/translateObjectName';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function openWidgetAndAddPhoneNumber(subjectId, objectTypeId) {
  openCallingWidget({
    toSubject: {
      objectId: subjectId,
      objectTypeId
    },
    addPhoneNumber: true
  });
}
function AddNumberLink({
  onClick,
  subjectId,
  objectTypeId
}) {
  const handleClick = useCallback(() => {
    onClick();
    openWidgetAndAddPhoneNumber(subjectId, objectTypeId);
  }, [objectTypeId, onClick, subjectId]);
  return /*#__PURE__*/_jsx(UIButton, {
    use: "link",
    onClick: handleClick,
    "data-selenium-test": "no-callees-add-phone-number",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "callee-selection.noCallees.addPhoneNumber"
    })
  });
}
function NoCalleesPrompt({
  objectTypeId,
  subjectId,
  onAddNumberClick = () => {},
  shouldShowAddNumber
}) {
  let message = null;
  if (objectTypeId === CONTACT_TYPE_ID) {
    message = /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx("strong", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "callee-selection.noCallees.headings.contactHasNoPhoneNumber"
          })
        })
      }), shouldShowAddNumber && /*#__PURE__*/_jsx(AddNumberLink, {
        onClick: onAddNumberClick,
        subjectId: subjectId,
        objectTypeId: objectTypeId
      })]
    });
  } else if (objectTypeId === COMPANY_TYPE_ID) {
    message = /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx("strong", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "callee-selection.noCallees.headings.companyHasNoPhoneNumber"
          })
        })
      }), /*#__PURE__*/_jsx(AddNumberLink, {
        onClick: onAddNumberClick,
        subjectId: subjectId,
        objectTypeId: objectTypeId
      })]
    });
  } else {
    message = /*#__PURE__*/_jsx("strong", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "callee-selection.noCallees.headings.noAssociatedRecords",
        options: {
          objectType: translateObjectName(objectTypeId)
        }
      })
    });
  }
  return /*#__PURE__*/_jsx("div", {
    className: "p-all-4",
    children: message
  });
}
NoCalleesPrompt.propTypes = {
  objectTypeId: ObjectTypeId.isRequired,
  onAddNumberClick: PropTypes.func.isRequired
};
export default /*#__PURE__*/memo(NoCalleesPrompt);